
export default {
    nuxtI18n: {
        paths: {
            fr: '/recits/:slug',
            es: '/relatos/:slug',
            en: '/stories/:slug'
        }
    }
};
